import { selectMarketByIso } from '../../../../features/markets'
import { useAppSelector } from '../../../../hooks/storeHooks'

export const useLiveEventsTrackingMarket = () => {
  const currentMarket = useAppSelector((state) => selectMarketByIso('en')(state, 'us'))
  return { currentMarketIso: 'us', currentMarket }
}
